import React, { useMemo } from "react";
import { cn } from "@/lib/utils";

interface VideoPagePreviewProps {
  refreshKey?: string;
  slug: string;
  email?: string;
  onClick?: () => void;
  backgroundColor?: string;
  textColor?: string;
  primaryCtaColor?: string;
  primaryCtaTextColor?: string;
  headerUri?: string;
  footerUris?: string[];
  showEhLenderLogo?: boolean;
  showEhOpportunityLogo?: boolean;
  disclaimer?: string;
  className?: string;
}

type Props = VideoPagePreviewProps;

export const VideoPagePreview: React.FC<Props> = ({
  refreshKey,
  onClick,
  email,
  slug,
  backgroundColor,
  textColor,
  primaryCtaColor,
  primaryCtaTextColor,
  headerUri,
  footerUris,
  showEhLenderLogo,
  showEhOpportunityLogo,
  disclaimer,
  className,
}) => {
  const host = location.hostname === "localhost" ? "localhost:4321" : location.host;

  const previewUrl = useMemo(() => {
    const params: { [key: string]: any } = {
      preview: true,
      backgroundColor,
      textColor,
      primaryCtaColor,
      primaryCtaTextColor,
      e: email,
    };
    if (headerUri) {
      params.headerUri = headerUri;
    }
    if (footerUris && footerUris.length > 0) {
      params.footerUris = footerUris.join(",");
    }
    if (showEhLenderLogo !== undefined) {
      params.showEhLenderLogo = showEhLenderLogo;
    }
    if (showEhOpportunityLogo !== undefined) {
      params.showEhOpportunityLogo = showEhOpportunityLogo;
    }
    if (disclaimer) {
      params.disclaimer = disclaimer;
    }
    const queryString = new URLSearchParams(params).toString();
    return `${location.protocol}//${host}/v/${slug}?${queryString}`;
  }, [
    backgroundColor,
    textColor,
    primaryCtaColor,
    primaryCtaTextColor,
    headerUri,
    footerUris,
    showEhLenderLogo,
    showEhOpportunityLogo,
    disclaimer,
    slug,
    email,
  ]);

  return (
    <div className={cn("w-full h-[600px]", className)} onClick={onClick}>
      <iframe
        key={previewUrl + "&refreshKey=" + refreshKey}
        src={previewUrl}
        className="w-full h-full border border-border rounded-md pointer-events-none no-scrollbar"
        seamless
      />
    </div>
  );
};
